import type { ReactNode } from 'react';

export type PastelColor = 'peach' | 'mint' | 'sky' | 'lemon' | 'lilac';
type Size = 'sm' | 'md' | 'lg';

const sizeStyles: Record<Size, string> = {
  sm: 'px-2.5 py-1 text-xs',
  md: 'px-3.5 py-1.5 text-[13px]',
  lg: 'px-[18px] py-2 text-sm',
};

const colorStyles: Record<PastelColor, string> = {
  peach: 'bg-peach text-peach-deep',
  mint: 'bg-mint text-mint-deep',
  sky: 'bg-sky text-sky-deep',
  lemon: 'bg-lemon text-lemon-deep',
  lilac: 'bg-lilac text-lilac-deep',
};

interface C2PillProps {
  color?: PastelColor;
  size?: Size;
  children?: ReactNode;
  className?: string;
}

export default function C2Pill({ children, color = 'peach', size = 'md', className = '' }: C2PillProps) {
  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 rounded-pill font-semibold',
        sizeStyles[size],
        colorStyles[color],
        className,
      ].join(' ')}
    >
      {children}
    </span>
  );
}
